export default {
  getAllDepots: function() {
    return axios.get("/depot/all");
  }
};
